import * as PrefabManager from '../PrefabManager';

import * as emitterManager from '../../utils/EmitterManager'
import * as PhysicsParticleEmitter from '../../utils/PhysicsParticleEmitter';
import * as AudioManager from '../../utils/AudioManager';
import { queueBreak } from '../../utils/BreakableManager';
import { Settings } from '../../Settings';

const JUICE_RADIUS = 12;

export class SoftBreakable extends PrefabManager.basePrefab {
    constructor(target) {
        super(target);

		this.breakingForce = 40;
		this.splashColors = ['#FFFFFF'];
		this.emitterType = 'splash';
		this.partsColors = [0xFFFFFF];
		this.partsType = ['Pumpkin2', 3];
		this.partsRandom = true;
		this.partsOffset = [0,0];
		this.partsQuantity = 6;
		this.partsSize = 5;
		this.partsForce = 10;
		this.sound = 'fruit-explode';
		this.doBreak = false;
		this.breakQueued = false;

	}

	init(){
		super.init();
        this.base = this.lookupObject['base'];

		if(!this.prefabObject.settings.isAwake){
            this.base.SetAwake(false);
			this.base.mySprite.data.awake = false;
        }
	}

	break(){
		if(this.destroyed || this.prefabObject.destroyed) return;
		const position = this.base.GetPosition();
		const splash = emitterManager.playOnceEmitter(this.emitterType, null, position, 0, this.splashColors);
		// Juice that falls and stains what it lands on, within the splash's limit.
		const juice = splash && emitterManager.playOnceEmitter('juiceRing', null, position, 0, this.splashColors);
		if(juice){
			const velocity = this.base.GetLinearVelocity();
			juice.spawnCircle = {x: 0, y: 0, r: JUICE_RADIUS};
			juice.setSpawnVelocity(velocity.x * Settings.PTM, velocity.y * Settings.PTM);
		}

		AudioManager.playSFX(this.sound, 0.2, 1.0 + 0.4 * Math.random()-0.2, position);

		if(this.prefabObject.settings.hasDebris){
			const parts = this.partsRandom
				? Array.from({length: this.partsType[1]}, (_, i) => `${this.partsType[0]}_${i+1}`)
				: this.partsType;
			PhysicsParticleEmitter.emitDebris(parts, position, this.partsQuantity, this.partsSize, this.partsForce, this.partsRandom, this.partsColors, this.base.GetAngle(), this.partsOffset);
		}

		this.destroy();
	}

	update(){
		if(this.doBreak && this.prefabObject.settings.isDestructible){
			queueBreak(this);
		}
	}

	initContactListener() {
        super.initContactListener();
        const self = this;
        this.contactListener.PostSolve = function (contact, impulse) {
			if(self.doBreak || self.destroyed || !self.prefabObject.settings.isDestructible) return;
			let force = 0;
			for (let j = 0, count = impulse.get_count(); j < count; j++){
				force = Math.max(force, impulse.get_normalImpulses(j));
			}
			if(force <= self.breakingForce) return;
			const skipBecauseToLight = contact.GetFixtureA().GetDensity() === 0.001 || contact.GetFixtureB().GetDensity() === 0.001;
			if (force > self.breakingForce && !skipBecauseToLight) {
				self.doBreak = true;
			}
		}
    }
}

SoftBreakable.settings = Object.assign({}, SoftBreakable.settings, {
    "isAwake": true,
    "isDestructible": true,
    "hasDebris": true,
});

SoftBreakable.settingsOptions = Object.assign({}, SoftBreakable.settingsOptions, {
    "isAwake": true,
	"isDestructible": true,
    "hasDebris": true,
});
